module.exports = __webpack_public_path__ + "files/96b02cb8a4ff1e4876220df6643d49e1.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activities-1.png
// module id = 519
// module chunks = 76